import AscButton from "../../../../AscButton/AscButton";
import AscHeading from "../../../../AscTypography/AscHeading/AscHeading";

import styles from "./AscActivityDragWord.module.scss";
import { AdminDragWordQuestions } from "@ascendnow/shared";
import AscDoubleTextQuestionAnswerForm from "../../../AscDoubleTextQuestionAnswerForm/AscDoubleTextQuestionAnswerForm";
import { useEffect } from "react";
import { useAscAddModuleActivitiesForm } from "../../useAscAddModuleActivitiesForm";

export default function AscActivityDragWord() {
  const formik = useAscAddModuleActivitiesForm();

  function handleChange(
    index: number,
    question: Partial<AdminDragWordQuestions["questions"]["questions"][number]>
  ) {
    const newQuestions = [
      ...(formik?.values?.dragWord?.questions?.questions || []),
    ];
    newQuestions[index] = { ...newQuestions[index], ...question };
    formik.setFieldValue("dragWord.questions.questions", newQuestions);
  }

  const handleDelete = (index: number) => {
    const newQuestions = [
      ...(formik?.values?.dragWord?.questions?.questions || []),
    ];
    newQuestions.splice(index, 1);
    if (newQuestions.length === 0) {
      newQuestions.push({
        question: "",
        answer: "",
      });
    }
    formik.setFieldValue("dragWord.questions.questions", newQuestions);
  };

  function addQuestion() {
    formik.setFieldValue("dragWord.questions.questions", [
      ...(formik?.values?.dragWord?.questions?.questions || []),
      { question: "", answer: "" },
    ]);
  }

  useEffect(() => {
    if (formik?.values?.dragWord?.questions?.questions?.length === 0) {
      addQuestion();
    }
  }, []);

  return (
    <div className={styles.ground}>
      <div className={styles.headerGround}>
        <AscHeading className={styles.header} level={6}>
          Questions & Answers
        </AscHeading>

        <AscButton
          className={styles.link}
          variant="link"
          hideLinkIcon={true}
          onClick={addQuestion}
        >
          Add question <span>+</span>
        </AscButton>
      </div>
      {formik?.values?.dragWord?.questions?.questions?.map(
        (question, index: number) => (
          <AscDoubleTextQuestionAnswerForm
            key={index}
            onChange={(question) => handleChange(index, question)}
            value={question}
            canDelete
            onDelete={() => handleDelete(index)}
          />
        )
      )}
    </div>
  );
}
